module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "helpMenuWrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "helpButtonGroup"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.helpCenterLink,
      "target": "_blank",
      "data-tooltip": "Have questions? Go to our NEW help center",
      "data-position": "right center",
      "data-inverted": ""
    }
  }, [_c('i', {
    staticClass: "ui dwhite big question circle outline icon"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "data-tooltip": "Contact us or report an issue",
      "data-position": "right center",
      "data-inverted": ""
    },
    on: {
      "click": [function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openHelpModal('second')
      }, function($event) {
        if (!$event.altKey) { return null; }
        if (!$event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.dvlprmd.apply(null, arguments)
      }]
    }
  }, [_c('i', {
    staticClass: "ui dwhite big bug icon"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "data-tooltip": "Suggest a new feature",
      "data-position": "right center",
      "data-inverted": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openHelpModal('third')
      }
    }
  }, [_c('i', {
    staticClass: "ui dwhite big lightbulb outline icon"
  })])]), _vm._v(" "), _c('HelpModal', {
    ref: "helpModal"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c30c0cf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpMenu.vue
// module id = 740
// module chunks = 2